export const SERVER_ERROR_TITLE = "Error de servidor";
export const GENERIC_ERROR_TITLE = "Ha ocurrido un error";
export const REQUEST_SUCCESS_TITLE = "Su solicitud ha sido enviada";
export const SERVER_ERROR_MESSAGE =
  "Intenta nuevamente, si el problema persiste, contacta con soporte.";
export const GENERIC_ERROR_MESSAGE = "Intenta nuevamente.";
export const REQUEST_CHANGE_PASSWORD_SUCCESS_MESSAGE =
  "Revisa tu correo para actualizar tu contraseña.";
export const CHANGE_PASSWORD_SUCCESS_TITLE =
  "La actualización de la contraseña ha sido exitosa";
export const CHANGE_PASSWORD_SUCCESS_MESSAGE =
  "Va a ser redirecionado a la pantalla de inicio de sesión.";
export const LOGIN_INVALID_CREDENTIALS_MESSAGE =
  "Email o contraseña incorrectos. Por favor, verifica tus datos e inténtalo de nuevo.";
export const LOGIN_SUCCESS_TITLE = "Inicio de sesión exitoso";
export const LOGIN_SUCCESS_MESSAGE = "Bienvenido de nuevo a StartFLY";
export const LOGIN_EMAIL_NOT_CONFIRMED =
  "El correo electrónico no ha sido confirmado. Verifica tu correo para confirmar tu cuenta.";

export const REGISTER_SUCCESS_TITLE = "Cuenta creada exitosamente";
export const REGISTER_SUCCESS_MESSAGE =
  "Revisa tu correo para confirmar tu cuenta y luego inicia sesión";
export const INFO_TITLE = "Información";
export const UPDATE_PASSWORD_PROCCESS_MESSAGE =
  "Se inicio el proceso de actualización de contraseña previamente. Por favor continué con el proceso para iniciar sesión.";
export const REPEATED_PASSWORD_ERROR_MESSAGE =
  "La contraseña debe ser diferente a la anterior.";
export const ACCOUNT_EXISTS_MESSAGE =
  "La cuenta con el email ingresado ya existe. Por favor, inicia sesión.";

export const CONFIRMATION_RESENT_TITLE = "Correo reenviado";
export const CONFIRMATION_RESENT_MESSAGE =
  "Revisa tu bandeja de entrada y la carpeta de spam.";
export const RESEND_RATE_LIMITED_TITLE = "Espera un momento";
export const RESEND_RATE_LIMITED_MESSAGE =
  "Ya enviamos un correo hace poco. Espera un minuto antes de reintentar.";
export const RECOVERY_RESENT_MESSAGE =
  "Si el correo está registrado, volvimos a enviarlo. Revisa spam y promociones.";
